/* Sort dropdown (Husse) — UI only; the stock <sort-by> element performs the sort. */
class SortDropdown extends HTMLElement {
  constructor() {
    super();
    this.toggle = this.querySelector('.sort-dropdown__toggle');
    this.label = this.querySelector('[data-sort-current]');
    this.toggle.addEventListener('click', () => this.setOpen(!this.classList.contains('is-open')));
    this.addEventListener('change', this.onChange.bind(this));
  }

  setOpen(open) {
    if (open) {
      document.querySelectorAll('sort-dropdown').forEach((dropdown) => dropdown !== this && dropdown.setOpen(false));
    }
    this.classList.toggle('is-open', open);
    this.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  onChange(event) {
    const radio = event.target;
    if (!radio.matches('.sort-dropdown__option input[type="radio"]')) return;

    const option = radio.closest('.sort-dropdown__option');
    const text = option ? option.textContent.trim() : radio.value;
    document.querySelectorAll('sort-dropdown').forEach((dropdown) => dropdown.select(radio.value, text));
  }

  select(value, text) {
    if (this.label) this.label.textContent = text;
    this.querySelectorAll('.sort-dropdown__option').forEach((option) => {
      const input = option.querySelector('input');
      option.classList.toggle('is-selected', Boolean(input) && input.value === value);
    });
    this.setOpen(false);
  }
}

if (customElements.get('sort-dropdown') === undefined) {
  customElements.define('sort-dropdown', SortDropdown);

  // Close on outside click / Escape.
  document.addEventListener('click', (event) => {
    document.querySelectorAll('sort-dropdown.is-open').forEach((dropdown) => {
      if (!dropdown.contains(event.target)) dropdown.setOpen(false);
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') document.querySelectorAll('sort-dropdown.is-open').forEach((dropdown) => dropdown.setOpen(false));
  });
}